export const RESET_PASSWORD_CLEAR = 'RESET_PASSWORD_CLEAR';
export const RESET_PASSWORD_SET_STRENGTH = 'RESET_PASSWORD_SET_STRENGTH';
export const RESET_PASSWORD_SHOW_POP_UP = 'RESET_PASSWORD_SHOW_POP_UP';
export const RESET_PASSWORD_HIDE_POP_UP = 'RESET_PASSWORD_HIDE_POP_UP';
export const RESET_PASSWORD_START = 'RESET_PASSWORD_START';
export const RESET_PASSWORD_FINISH = 'RESET_PASSWORD_FINISH';
